import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import Button from "components/atoms/Button/Button";
import errorToast from "helpers/errorToast";
import usePermissions from "hooks/usePermissions";
import { updateUser } from "api";
import testIds from "constants/testIds";
import Alert from "../Alert/Alert";

function TimezoneBanner({ setTimezoneBannerShown }) {
  const { permissions } = usePermissions();
  const { preferred_timezone } = permissions ? JSON.parse(permissions) : {};
  const browser_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isTimezoneBannerDismissed = Cookies.get("isTimezoneBannerDismissed");
  const isTimezoneBannerHidden =
    isTimezoneBannerDismissed || preferred_timezone === browser_timezone || Cookies.get("is_guest") === "true";
  const isLoggedInAsBannerShowing = Cookies.get("cargobase_logged_in_as_token");

  const [isHidden, setIsHidden] = useState(isTimezoneBannerHidden);

  useEffect(() => {
    setTimezoneBannerShown(!isHidden);
  }, [isHidden]);

  const onDismiss = () => {
    Cookies.set("isTimezoneBannerDismissed", true);
    setIsHidden(true);
  };

  const onUpdate = () => {
    updateUser({ timezone: browser_timezone })
      .then(() =>
        toast(
          <FormattedMessage id="components.molecules.timezone-banner.timezoneUpdated" defaultMessage="Timezone updated" />,
          { type: "success" },
        ),
      )
      .catch((err) => errorToast(err))
      .then(() => setIsHidden(true));
  };

  const styles = {
    zIndex: 5,
    position: "fixed",
    width: "100%",
    bottom: isLoggedInAsBannerShowing ? 34 : 0,
    backgroundColor: "#EDF6D3",
  };

  if (isHidden) return;
  return (
    <div style={styles} className="hide-during-print">
      <Alert variant="success">
        <div className="d-flex align-items-center">
          <p className="mb-0">
            <FormattedMessage
              id="components.molecules.timezone-banner.updateTimezoneTo"
              defaultMessage="Update timezone to"
            />{" "}
            {browser_timezone}?
          </p>
          <Button
            variant="success"
            size="sm"
            className="ml-4 py-2"
            onClick={onUpdate}
            data-testid={testIds.TIMEZONE_BANNER_UPDATE_BUTTON}
          >
            <FormattedMessage id="general.update" defaultMessage="Update" />
          </Button>
          <Button variant="link" size="sm" className="ml-2" onClick={onDismiss}>
            <FormattedMessage id="general.ignore" defaultMessage="Ignore" />
          </Button>
        </div>
      </Alert>
    </div>
  );
}

TimezoneBanner.propTypes = {
  setTimezoneBannerShown: PropTypes.func.isRequired,
};

export default TimezoneBanner;
